const ENDPOINT = new Map();
ENDPOINT.set('search', '/search');
ENDPOINT.set('trending', '/trending');

export default ENDPOINT
